import ErrorBoundary from 'components/ErrorBoundary'
import React, { useState } from 'react'
import SearchDashboard from './SearchDashboard'
import { Card, CardBody, CardHeader, CardTitle, Col, Container, Row } from 'reactstrap'
import useContextService from 'hooks/useContextService'
import FinacialIcon from "../../assets/icon/DashboardFinacial.svg";
import DashboardProgram from "../../assets/icon/DashboradHelathIcon.svg";
import DashboardHealthimages from "../../assets/icon/DashboardHealthimages.svg";
import DashboardHelath1 from "../../assets/icon/HealthImage2.svg";
import DashboardHelath2 from "../../assets/icon/HealthImg2.svg";
import Programover from './Components/Programover'
import { dateFormate } from 'utils/columns'
import CTooltip from "react-tooltip-lite";
import DrugSpend from './Components/DrugSpend'
import WacInpact from './Components/WacInpact'
import TopDrugs from './Components/TopDrugs'
import WholesalerSpend from './Components/WholesalerSpend'
import Drugutlization from './Drugutlization'
import Drawer from 'components/Drawer'


const Dashboard = (props) => {
    const {  orgId } = props;
    const {
        states: { dashboard },
        setStates,
      } = useContextService();
      const { search, searchTerms } = dashboard;
      const[selectsearch,setSelectSearch]=useState(false)
      const[drugutlization,setDrugutlization]=useState(false)
      const togglesDrawer = () => {
        setDrugutlization(!drugutlization);
      };
      const [startDateVAlue, setStartDateValue]= useState(null);
      const [endDateVAlue, setEndDateValue]= useState(null);
    
    const counterData=[
        {iconName:"340B Spend",value:"$ 98,729.65"},
        {iconName:"GPO Spend",value:"$ 94,229.15"},
        {iconName:"WAC Spend",value:"$ 96,689.85"},
        {iconName:"340B Savings ",value:"$ 91,327.35"},
        {iconName:"WAC Impact",value:"$ 93,426.25"},
        {iconName:"NET 340B Savings",value:"$ 92,327.45"},
    ]
const filesData=[
    
        {
            "fileType": "Drug Utilization File",
            "fileName": null,
            "recordsCount": 4198,
            "recentReceivedDate": "2025-03-19T00:00:00",
            "days": 0,
            "delayLoad": "N",
            "delayedDate": "2025-03-17T00:00:00",
            "singleCESelected": false,
            "img":1,
            "fileType1":1
            
        },
        {
            "fileType": "Locations",
            "fileName": null,
            "recordsCount": 4,
            "recentReceivedDate": "2025-03-19T00:00:00",
            "days": 0,
            "delayLoad": "N",
            "delayedDate": "2025-03-17T00:00:00",
            "singleCESelected": false,
            "img":1
        },
        {
            "fileType": "Patient Types",
            "fileName": null,
            "recordsCount": 2,
            "recentReceivedDate": "2025-03-10T11:22:27.427",
            "days": 0,
            "delayLoad": "N",
            "delayedDate": null,
            "singleCESelected": false,
            "img":1
        },
        {
            "fileType": "Charge Codes",
            "fileName": null,
            "recordsCount": 0,
            "recentReceivedDate": "2025-03-20T12:26:52.36",
            "days": 0,
            "delayLoad": "N",
            "delayedDate": null,
            "singleCESelected": false,
            "img":2

        },
        {
            "fileType": "NDC's",
            "fileName": null,
            "recordsCount": 0,
            "recentReceivedDate": "2025-03-20T12:32:58.427",
            "days": 0,
            "delayLoad": "N",
            "delayedDate": null,
            "singleCESelected": false,
            "img":2

        }
    
]
const onsearch = ()=>{
  debugger;
  setSelectSearch(true)
}
const reset=()=>{

}

  return (
    <div>
        <Container fluid className="width_info">
            <div>
                <ErrorBoundary>
                <Card className="border-0 shadow-top">
                <CardBody>
                <SearchDashboard orgId={orgId} search={search} searchTerms={searchTerms} onsearch={onsearch} selectsearch={selectsearch}  setSelectSearch={setSelectSearch} 
                startDateValue={startDateVAlue} 
                setStartdate={setStartDateValue}
                endDateValue={endDateVAlue} 
                setEndDate={setEndDateValue} 
                 />

                    </CardBody>
                    </Card>
                </ErrorBoundary>
            </div>
            <div>
            <Row sm={2} xs={1}>
                <Col md={12}>
                  <Row>
                    <Col className="mt-3" md={7}>
                      {/* <ClaimCapturedRep
                        months={months}
                        capture={capture}
                        replenished={replenished}
                      /> */}
                      <Programover selectsearch={selectsearch}/>
                    </Col>
                    <Col md={5}>
                      <Row>
                        <Col md={6} className="mt-3">
                          <Card className="h-100 border-0 shadow-top" style={{ borderRadius: "4px" }}>
                            <CardHeader className="border-0 bg-white" style={{ borderRadius: "4px" }}>
                              <Row className="align-items-center">
                                <Col className="d-flex justify-content-between">
                                  <CardTitle
                                    className="f-20 font-weight-500 mb-0 scroll"
                                  >
                                    Financial
                                    <span className="d-block">Summary</span>
                                  </CardTitle>
                                  <img src={FinacialIcon} />
                                </Col>
                              </Row>
                              <div className="mt-3" hidden={selectsearch==false}>
                                {counterData?.map((item, index) => {
                                  return (
                                    <div key={index} className="mt-3 border-btm-line">
                                      <div className="finacial-heading">
                                        {/* <CTooltip
                                          content={
                                            <div className="tip-list-info">
                                              <p>{item?.tooltip}</p>
                                            </div>
                                          }
                                        >
                                             
                                        </CTooltip> */}
                                        <span className="finacial-heading">
                                            {item.iconName}
                                          </span>
                                      </div>
                                      <div className="finacial-value mt-2">
                                        {item?.value}
                                      </div>
                                      {/* <div className="border"></div> */}
                                    </div>
                                  );
                                })}
                              </div>
                            </CardHeader>
                            {/* <CardBody className="dashboard-chart-body">
                              <div className="dashboard-chart-height"></div>
                            </CardBody> */}
                          </Card>
                        </Col>
                        <Col md={6} className="mt-3">
                          <Card className="h-100 border-0 shadow-top" style={{ borderRadius: "4px" }}>
                            <CardHeader className="border-0 bg-white" style={{ borderRadius: "4px" }}>
                              <Row className="align-items-center">
                                <Col className="d-flex justify-content-between">
                                  <CardTitle className="f-20 font-weight-500 mb-0 scroll">
                                    Program
                                    <span className="d-block">Health</span>
                                  </CardTitle>
                                  <img src={DashboardProgram} />
                                </Col>
                              </Row>
                              
                              <div className="mt-3" hidden={selectsearch==false}>
                                {filesData.map((item) => {
                                    console.log(item,"filetype")
                                  let imagevalue = "";
                                  const currentDate = new Date();
                                  const twoDaysAgo = new Date(currentDate);
                                  twoDaysAgo.setDate(currentDate.getDate() - 2);
                                  const threeDaysAgo = new Date(currentDate);
                                  threeDaysAgo.setDate(
                                    currentDate.getDate() - 3
                                  );

                                  const recentReceivedDate = new Date(
                                    item.recentReceivedDate
                                  );

                                  // if (recentReceivedDate < threeDaysAgo) {
                                  //   imagevalue = 3;
                                  // } else if (recentReceivedDate < twoDaysAgo) {
                                  //   imagevalue = 2;
                                  // } else {
                                  //   imagevalue = 1;
                                  // }

                                  return (
                                    <div>
                                      {imagevalue == 3 ? (
                                          <Row className="mt-3 border-btm-line">
                                          <Col md={12}>
                                            <div className="mt-2 ">
                                              <div className="finacial-heading d-flex justify-content-between  align-items-center">
                                                <span className="finacial-heading1 ">
                                                  {(item.fileType1 === "1") ?
                                                    (
                                                      <span
                                                        className="cursor-pointer text-decoration-underline"
                                                        onClick={() => togglesDrawer()}>
                                                        {item.fileType}
                                                      </span>
                                                    )
                                                    : (item.fileType == "Encounter") ?
                                                      (
                                                        < span
                                                          className="cursor-pointer text-decoration-underline"
                                                          onClick={() => handleEncounters()}>
                                                          {item.fileType}
                                                        </span>
                                                      ) : (
                                                        item.fileType
                                                      )}
                                                </span>
                                                <span className="finacial-heading1-1">
                                                  Last Updated
                                                </span>
                                              </div>
                                              <div className=" d-flex justify-content-between align-items-center mt-3">
                                                <span className="finacial-value1 d-flex align-items-center">
                                                {item.recordsCount} {" "} <span className="finacial-heading1-1 ms-1">{item.img==2?"Unmapped":"Pending"}</span>
                                              
                                                </span>
                                                <div className="d-flex justify-content-end w-100">
                                                  <span className="finacial-value1-1 f-600" style={{ paddingRight: "10px" }}>
                                                    {dateFormate(
                                                      item.recentReceivedDate
                                                    )}
                                                  </span>
                                                    <div
                                                    style={{
                                                      display: "flex",
                                                      // marginBottom: "10px",
                                                      justifyContent: "center",
                                                      alignItems: "flex-end",
                                                      position: "relative",
                                                      bottom: "3px"
                                                    }}
                                                  >
                                                   {item.img == 2 ? (
                                                    <img
                                                      src={DashboardHealthimages}
                                                    />
                                                  ) : (
                                                    ""
                                                  )}
                                                  {item.img == 1 ? (
                                                    <img src={DashboardHelath2} />
                                                  ) : (
                                                    ""
                                                  )}
                                                  
                                                  </div>
                                                </div>
                                              </div>
                                              {/* <div className="border"></div> */}
                                            </div>
                                          </Col>
                                          {/* <Col md={2} className="d-flex">
                                            <div
                                              style={{
                                                display: "flex",
                                                // marginBottom: "10px",
                                                justifyContent: "center",
                                                alignItems: "flex-end",
                                                position: "relative",
                                                bottom: "5px"
                                              }}
                                            >
                                              {imagevalue == 1 ? (
                                                <img
                                                  src={DashboardHealthimages}
                                                />
                                              ) : (
                                                ""
                                              )}
                                              {imagevalue == 2 ? (
                                                <img src={DashboardHelath2} />
                                              ) : (
                                                ""
                                              )}
                                              {imagevalue == 3 ? (
                                                <img src={DashboardHelath2} />
                                              ) : (
                                                ""
                                              )}
                                            </div>
                                          </Col> */}
                                        </Row>) : (
                                        <Row className="mt-3 border-btm-line">
                                        <Col md={12}>
                                          <div className="mt-2 ">
                                            <div className="finacial-heading d-flex justify-content-between  align-items-center">
                                              <span className="finacial-heading1 ">
                                                {(item.fileType1 == "1") ?
                                                  (
                                                    <span
                                                      className="cursor-pointer text-decoration-underline"
                                                      onClick={() => togglesDrawer()}>
                                                      {item.fileType}
                                                    </span>
                                                  )
                                                  : (item.fileType == "Encounter") ?
                                                    (
                                                      < span
                                                        className="cursor-pointer text-decoration-underline"
                                                        onClick={() => handleEncounters()}>
                                                        {item.fileType}
                                                      </span>
                                                    ) : (
                                                      item.fileType
                                                    )}
                                              </span>
                                              <span className="finacial-heading1-1">
                                                Last Updated
                                              </span>
                                            </div>
                                            <div className=" d-flex justify-content-between align-items-center mt-3">
                                              <span className="finacial-value1 d-flex align-items-center">
                                              {item.recordsCount} {" "} <span className="finacial-heading1-1 ms-1">{item.img==2?"Unmapped":"Pending"}</span>
                                            
                                              </span>
                                              <div className="d-flex justify-content-end w-100">
                                                <span className="finacial-value1-1 f-600" style={{ paddingRight: "10px" }}>
                                                  {dateFormate(
                                                    item.recentReceivedDate
                                                  )}
                                                </span>
                                                  <div
                                                  style={{
                                                    display: "flex",
                                                    // marginBottom: "10px",
                                                    justifyContent: "center",
                                                    alignItems: "flex-end",
                                                    position: "relative",
                                                    bottom: "3px"
                                                  }}
                                                >
                                                  {item.img == 2 ? (
                                                    <img
                                                      src={DashboardHealthimages}
                                                    />
                                                  ) : (
                                                    ""
                                                  )}
                                                  {item.img == 1 ? (
                                                    <img src={DashboardHelath2} />
                                                  ) : (
                                                    ""
                                                  )}
                                                
                                                </div>
                                              </div>
                                            </div>
                                            {/* <div className="border"></div> */}
                                          </div>
                                        </Col>
                                        {/* <Col md={2} className="d-flex">
                                          <div
                                            style={{
                                              display: "flex",
                                              // marginBottom: "10px",
                                              justifyContent: "center",
                                              alignItems: "flex-end",
                                              position: "relative",
                                              bottom: "5px"
                                            }}
                                          >
                                            {imagevalue == 1 ? (
                                              <img
                                                src={DashboardHealthimages}
                                              />
                                            ) : (
                                              ""
                                            )}
                                            {imagevalue == 2 ? (
                                              <img src={DashboardHelath1} />
                                            ) : (
                                              ""
                                            )}
                                            {imagevalue == 3 ? (
                                              <img src={DashboardHelath2} />
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                        </Col> */}
                                      </Row>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                              
                            </CardHeader>
                            {/* <CardBody className="dashboard-chart-body">
                              <div className="dashboard-chart-height"></div>
                            </CardBody> */}
                          </Card>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="mt-3" md={6}>
                      <DrugSpend
                      selectsearch={selectsearch}

                      />
                    </Col>
                    <Col className="mt-3" md={6}>
                      <WacInpact                       selectsearch={selectsearch}
                      />
                    </Col>
                    <Col className="mt-3" md={6}>
                      {/* <NonCapturedClaims
                        months={months}
                        capture={nonCaptured}
                      /> */}
                      <TopDrugs                       selectsearch={selectsearch}
                      />
                    </Col>
                    <Col className="mt-3" md={6}>
                    <WholesalerSpend                       selectsearch={selectsearch}
                    />
                      {/* <TopPharmacy data={topPharmaciesSavings} /> */}
                    </Col>
                   
                  </Row>
                </Col>
              </Row>
            </div>
            <Drawer
                direction="end"
                title="Drug Utilization"
                isOpen={drugutlization}
                toggle={togglesDrawer}
                size="lg"
              >
                <Drugutlization
                  // orgId={orgId}
                  // tenantID={tenantID}
                  // onClose={ePrescriptiondrawerClose}
                  // randNum={randNum}
                />
              </Drawer>

        </Container>
    </div>
  )
}

export default Dashboard